var map = {
	"./ar/menu.json": "./src/locale/ar/menu.json",
	"./cs/menu.json": "./src/locale/cs/menu.json",
	"./cy/menu.json": "./src/locale/cy/menu.json",
	"./da/menu.json": "./src/locale/da/menu.json",
	"./de/menu.json": "./src/locale/de/menu.json",
	"./en/menu.json": "./src/locale/en/menu.json",
	"./es/menu.json": "./src/locale/es/menu.json",
	"./fi/menu.json": "./src/locale/fi/menu.json",
	"./fr/menu.json": "./src/locale/fr/menu.json",
	"./he/menu.json": "./src/locale/he/menu.json",
	"./hr/menu.json": "./src/locale/hr/menu.json",
	"./hu/menu.json": "./src/locale/hu/menu.json",
	"./it/menu.json": "./src/locale/it/menu.json",
	"./ja/menu.json": "./src/locale/ja/menu.json",
	"./kk/menu.json": "./src/locale/kk/menu.json",
	"./ko/menu.json": "./src/locale/ko/menu.json",
	"./nl/menu.json": "./src/locale/nl/menu.json",
	"./pl/menu.json": "./src/locale/pl/menu.json",
	"./pt/menu.json": "./src/locale/pt/menu.json",
	"./ro/menu.json": "./src/locale/ro/menu.json",
	"./ru/menu.json": "./src/locale/ru/menu.json",
	"./sh/menu.json": "./src/locale/sh/menu.json",
	"./sk/menu.json": "./src/locale/sk/menu.json",
	"./sr/menu.json": "./src/locale/sr/menu.json",
	"./sv/menu.json": "./src/locale/sv/menu.json",
	"./vi/menu.json": "./src/locale/vi/menu.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/menu\\.json$";